module.exports = "<div [class.splitted]=\"splittedDisplay\" *ngIf=\"contactMethod\">\n  <div class=\"contact-info -{{numberDisplay}} -{{ contactMethod.kind }}\" [class.-icon]=\"showIcon\">\n    <div class=\"text\">\n      <span class=\"kind\">{{'common.contact_method_kinds.' + kind | translate}}</span>\n    </div>\n    <span class=\"number\">{{ contactMethod.number | phone }}</span>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/contact-method/contact-method.component.html
// module id = 1183
// module chunks = 0